import React from "react";
import InstallAppButton from "./InstallAppButton";

import {
  FaMapMarkerAlt,
  FaEnvelope,
  FaLinkedin,
  FaGithub,
  FaFacebook,
} from "react-icons/fa";

export default function Contact() {
  return (
    <section id="contact">
      <h2>Contact Harpreet Singh</h2>

      <p>
        If you would like to get in touch with Harpreet Singh regarding
        software development, project management, technology, collaboration,
        or professional opportunities, you can use the contact details below.
      </p>

      <div className="contact-grid">
        <div className="contact-item">
          <FaMapMarkerAlt className="contact-icon" />

          <p>
            <strong>Location:</strong> Kharar, Punjab, India
          </p>
        </div>

        <div className="contact-item">
          <FaEnvelope className="contact-icon" />

          <p>
            <strong>Email:</strong>{" "}
            <a href="mailto:harpreet.7976@gmail.com">
              harpreet.7976@gmail.com
            </a>
          </p>
        </div>

        <div className="contact-item">
          <FaLinkedin className="contact-icon" />

          <p>
            <strong>LinkedIn:</strong>{" "}
            <a
              href="https://www.linkedin.com/in/harpreet-singh-485a2928"
              target="_blank"
              rel="noreferrer"
            >
              LinkedIn Profile
            </a>
          </p>
        </div>

        <div className="contact-item github-item">
          <FaGithub className="contact-icon" />

          <div className="github-info">
            <p>
              <strong>GitHub:</strong>{" "}
              <a
                href="https://github.com/singhpreet86"
                target="_blank"
                rel="noreferrer"
              >
                GitHub Profile
              </a>
            </p>

            <InstallAppButton />
          </div>
        </div>

        <div className="contact-item">
          <FaFacebook className="contact-icon" />

          <p>
            <strong>Facebook:</strong>{" "}
            <a
              href="https://www.facebook.com/harpreet.singh.803260"
              target="_blank"
              rel="noreferrer"
            >
              Facebook Profile
            </a>
          </p>
        </div>
      </div>

      <style jsx>{`
        .contact-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
          gap: 20px;
          margin-top: 20px;
        }

        .contact-item {
          display: flex;
          align-items: flex-start;
          gap: 15px;
          padding: 15px;
          border: 1px solid #ddd;
          border-radius: 8px;
          transition: box-shadow 0.3s;
        }

        .contact-item:hover {
          box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
        }

        .contact-icon {
          font-size: 24px;
          color: #0073b1;
          margin-top: 3px;
          flex-shrink: 0;
        }

        a {
          color: inherit;
          text-decoration: underline;
        }
      `}</style>
    </section>
  );
}
